export default [  
    {
      id: '1',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/32201.png',
      symbol: 'POΞ',
      name: 'POΞ',
      decimals: '18',
      address: '0xd429a52a56c712aB8ba11EaCd8Bf178E7c3b4D80', 
      vesting_period: '24 Months',
      explorer: 'https://basescan.org/', 
      network: "Base",
      display_price: "0.0...21",
      exchange_rate: '0.000021',
      initial_price: "0.000009543",
      coinmarketcap: "https://coinmarketcap.com/currencies/poe/"
    },  
    {
      id: '2',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/30492.png',
      symbol: 'BENG',
      name: 'Based Peng',
      decimals: '18',
      address: '0x3e05D37CFBd8caaad9E3322D35CC727AfaFF63E3', 
      vesting_period: '24 Months',
      explorer: 'https://basescan.org/', 
      network: "Base",
      display_price: "0.0...81",
      exchange_rate: '0.0000081',
      initial_price: "0.000002466",
      coinmarketcap: "https://coinmarketcap.com/currencies/based-peng/"
    },  
    {
      id: '3',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/30435.png',
      symbol: 'BUIDL',
      name: 'BUIDL 404',
      decimals: '18',
      address: '0x40Be61a8C047e84Aa974eac296eaaBF09945D3b2', 
      vesting_period: '24 Months',
      explorer: 'https://basescan.org/', 
      network: "Base",
      display_price: "0.0159",
      exchange_rate: '0.0159',
      initial_price: "0.005328",
      coinmarketcap: "https://coinmarketcap.com/currencies/starter-xyz/"
    },  
    {
      id: '4',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/24616.png',
      symbol: 'SNAIL',
      name: 'SnailBrook',
      decimals: '18',
      address: '0x6Bc40d4099f9057b23aF309C08d935b890d7Adc0', 
      vesting_period: '24 Months',
      explorer: 'https://basescan.org/', 
      network: "Base",
      display_price: "0.0...41",
      exchange_rate: '0.000041',
      initial_price: "0.00003485",
      coinmarketcap: "https://coinmarketcap.com/currencies/snailbrook/"
    },  
    {
      id: '5',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/32318.png',
      symbol: 'LAZYCAT',
      name: 'LazyCat',
      decimals: '9',
      address: '0x41eD891897117450adBd710006855B12F98cb86b', 
      vesting_period: '24 Months',
      explorer: 'https://basescan.org/', 
      network: "Base",
      display_price: "0.00015",
      exchange_rate: '0.00015',
      initial_price: "0.00006003",
      coinmarketcap: "https://coinmarketcap.com/currencies/lazycat/"
    },  
    {
      id: '6',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/29956.png',
      symbol: '$ETF',
      name: 'ETHTrustFund',
      decimals: '18',
      address: '0x6cf727d9089a07e44607bea30f5e687983ca6aa1', 
      vesting_period: '24 Months',
      explorer: 'https://basescan.org/', 
      network: "Base",
      display_price: "0.0...14",
      exchange_rate: '0.0000000000014',
      initial_price: "0.000000000000498",
      coinmarketcap: "https://coinmarketcap.com/currencies/eth-trust-fund/"
    },  
    {
      id: '7',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/31797.png',
      symbol: 'NORMUS',
      name: 'NORMUS',
      decimals: '18',
      address: '0xBA5EDE8d98ab88CEa9f0D69918ddE28Dc23c2553', 
      vesting_period: '24 Months',
      explorer: 'https://basescan.org/', 
      network: "Base",
      display_price: "0.00015",
      exchange_rate: '0.00015',
      initial_price: "0.00005211",
      coinmarketcap: "https://coinmarketcap.com/currencies/basednormus/"
    },  
  ];
  